import { VariantCharacters } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantCharacters.tsx';
import { VariantPoint } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantPoint.tsx';
import { VariantStar } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantStar.tsx';
import { VariantSizes } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import { VariantWrapText } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/VariantWrapText.tsx';
import styled, { CSSProperties } from 'styled-components';

interface VIPointProps {
    color: string;
    highlighted: boolean;
    title: string;
    size: VariantSizes;
    sublabel?: string | null | undefined;
    style?: CSSProperties;
    className?: string;
}

export const VIPoint = (props: VIPointProps) => {
    return (
        <S_VIPoint className={props.className} style={props.style}>
            <S_WrapIcon>
                {!props.sublabel && <VariantPoint color={props.color} />}
                {props.sublabel && <VariantCharacters characters={props.sublabel} />}
                {props.highlighted && props.size !== 1 && (
                    <S_VariantStar
                        style={props.sublabel ? { top: -7, right: -7 } : { top: -10, right: -10 }}
                    />
                )}
            </S_WrapIcon>
            {props.size === 3 && (
                <S_VariantWrapText
                    top={props.sublabel ? 28 : 17}
                    variantText={{ text: props.title }}
                />
            )}
        </S_VIPoint>
    );
};

const S_VIPoint = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: relative;
`;

const S_WrapIcon = styled.div`
    position: relative;
    z-index: 1;
`;

const S_VariantStar = styled(VariantStar)`
    position: absolute;
`;

const S_VariantWrapText = styled(VariantWrapText)`
    z-index: 2;
`;
